import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-homepage-dialog',
    templateUrl: './homepage-dialog.component.html',
    styleUrls: ['./homepage-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomepageDialogComponent {
  constructor(public dialogRef: MatDialogRef<HomepageDialogComponent, void>) {}

  onClose() {
    this.dialogRef.close();
  }
}
